import {PaginationData} from '_components/admin/admin.types';
import {Prescriber} from '_redux/admin/prescribers/admin-prescriber-model.types';
import {Therapist} from '_redux/admin/therapists/admin-therapist-model.types';
import {
  NormalizedFetchedPrescribers,
  NormalizedFetchedTherapists,
  ProvidersModelTypes,
} from '_redux/calendar/calendar.types';
import {normalize, NormalizedSchema, schema} from 'normalizr';

export function createNormalizedPayload(
  data: Therapist[],
  entitySchema: schema.Entity<Therapist>,
  filter: ProvidersModelTypes.therapists,
  pagination?: PaginationData,
): NormalizedFetchedTherapists;

export function createNormalizedPayload(
  data: Prescriber[],
  entitySchema: schema.Entity<Prescriber>,
  filter: ProvidersModelTypes.prescribers,
  pagination?: PaginationData,
): NormalizedFetchedPrescribers;

export function createNormalizedPayload<T extends Therapist | Prescriber>(
  data: T[],
  entitySchema: schema.Entity<T>,
  filter: ProvidersModelTypes,
  pagination?: PaginationData,
) {
  const normalized: NormalizedSchema<
    {[key: string]: {[id: string]: T}},
    string[]
  > = normalize(data, [entitySchema]);

  if (filter === ProvidersModelTypes.therapists) {
    return {
      entities: {
        therapists: normalized.entities.therapists || {},
      },
      result: normalized.result,
      pagination,
      filter,
    } as NormalizedFetchedTherapists;
  } else {
    return {
      entities: {
        prescribers: normalized.entities.prescribers || {},
      },
      result: normalized.result,
      pagination,
      filter,
    } as NormalizedFetchedPrescribers;
  }
}
